module.exports = __webpack_public_path__ + "static/media/landing_shot1.2dc29562.jpg";